export const contactReason = {
    'en': [{
        name: 'Buy',
        value: 'buy'
    },
    {
        name: 'Sell',
        value: 'sell'
    },
    {
        name: 'Rent',
        value: 'rent'
    },
    {
        name: 'Other',
        value: 'other'
    }],
    'cn': [{
        name: '购买',
        value: 'buy'
    },
    {
        name: '卖出',
        value: 'sell'
    },
    {
        name: '出租',
        value: 'rent'
    },
    {
        name: '其他',
        value: 'other'
    }],
    'th': [{
        name: 'ซื้อ',
        value: 'buy'
    },
    {
        name: 'ขาย',
        value: 'sell'
    },
    {
        name: 'เช่า',
        value: 'rent'
    },
    {
        name: 'อื่น ๆ',
        value: 'other'
    }],
    'ru': [{
        name: 'Купить',
        value: 'buy'
    },
    {
        name: 'Продать',
        value: 'sell'
    },
    {
        name: 'Арендовать',
        value: 'rent'
    },
    {
        name: 'Другое',
        value: 'other'
    }],
    'de': [{
        name: 'Kaufen',
        value: 'buy'
    },
    {
        name: 'Verkaufen',
        value: 'sell'
    },
    {
        name: 'Mieten',
        value: 'rent'
    },
    {
        name: 'Andere',
        value: 'other'
    }],
    'fr': [{
        name: 'Acheter',
        value: 'buy'
    },
    {
        name: 'Vendre',
        value: 'sell'
    },
    {
        name: 'Louer',
        value: 'rent'
    },
    {
        name: 'Autre',
        value: 'other'
    }]
}